import { flexRender, Table, Column } from '@tanstack/react-table'
import { TableHeader, TableRow, TableHead } from '@/components/shadcn/table'
import clsx from 'clsx'

interface DataTableHeaderV2Props<TData> {
  table: Table<TData>
  frozenColOffsetsById: Record<string, number>
  leafColumns: Column<TData, unknown>[]
  freezePane?: number
  headerMeasureRefs: React.MutableRefObject<Record<string, HTMLDivElement | null>>
}

export function DataTableHeaderV2<TData>({
  table,
  frozenColOffsetsById,
  leafColumns,
  freezePane,
  headerMeasureRefs,
}: DataTableHeaderV2Props<TData>) {
  return (
    <TableHeader className="bg-offwhite sticky top-0 z-10">
      {table.getHeaderGroups().map((headerGroup) => (
        <TableRow key={headerGroup.id}>
          {headerGroup.headers.map((header) => {
            const isActionCol = header.id === 'actions' || header.id === 'rowActions'
            const explicitSize = header.column.columnDef.size as number | undefined

            const isFrozen = freezePane && frozenColOffsetsById[header.column.id] !== undefined
            const leftOffset = isFrozen ? frozenColOffsetsById[header.column.id] : undefined
            const isLastFrozen = isFrozen && freezePane && leafColumns[freezePane - 1]?.id === header.column.id

            return (
              <TableHead
                className={clsx('bg-offwhite sticky top-0 whitespace-nowrap border-b', {
                  'z-10 overflow-visible': !isFrozen && !isActionCol,
                  'right-0 z-10': isActionCol,
                  'z-20 border-r': isFrozen,
                  'drop-shadow-sm': isLastFrozen,
                })}
                key={header.id}
                style={{
                  width: explicitSize ? `${explicitSize}px` : undefined,
                  left: isFrozen ? `${leftOffset}px` : undefined,
                }}
              >
                <div
                  ref={(el) => {
                    headerMeasureRefs.current[header.column.id] = el
                  }}
                  className="inline-block whitespace-nowrap"
                >
                  {flexRender(header.column.columnDef.header, header.getContext())}
                </div>
              </TableHead>
            )
          })}
        </TableRow>
      ))}
    </TableHeader>
  )
}
